// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"solutions-cards_titleContainer__ogI_g","solutionsCardsTitle":"solutions-cards_solutionsCardsTitle__egGO6","content":"solutions-cards_content__x0b6e"};